import {
  createContainer,
  createMergeEstimate,
  createMergeFile,
  emptyCurrentFolderInFileManager,
  getFileVersions,
  getResourcesUnderWhichFilesShared,
  minimiseFileUpload,
  processFileList,
  selectedFilesFileManager,
  setCurrentFolderInFileManager,
  setCurrentPath,
  refreshFileManager as refreshFileManagerFn,
} from "@Actions/fileUpload";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import DropDownListComponent from "@CubeComponents/form/DropdownListComponent";
import ToggleSwitchComponent from "@CubeComponents/form/ToggleSwitchComponent";
import axiosWrapper from "@Services/axiosWrapper";
import {
  containerFileTypes,
  DRAWING_TYPE,
  formatBytes,
  modulesNameSynonymMapper,
  PDF_ENGINE,
  PDF_TYPE,
  SOMETHING_WENT_WRONG,
  TOAST_TYPE_ERROR,
  TOAST_TYPE_SUCCESS,
  TOAST_TYPE_WARNING,
} from "@Services/constants";
import { getBackendUrl } from "../../utils";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Query } from "@syncfusion/ej2-data";
import { setSpaceToggle } from "@Actions/AccessPermissionAction";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import IconComponent from "@CubeComponents/icons";
import FileManagerComponent from "../../cubeComponent/FileManager/FileManagerComponent";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Divider, Fade, FormControl, Menu, MenuItem, Select, Tab, Tabs } from "@mui/material";
import { showToastNotification } from "@Actions/toast";
import { getViewerUrl, MAX_FILE_UPLOAD_SIZE } from "../../../../helpers";
import { setViewerState } from "../../reducers/Viewer";
import {
  getContractDetailUrl,
  getEstimateUrl,
  getScheduleUrl,
  isFileNomenclatureCorrect,
} from "@Services/utils/helpers";
import ReviewsList from "@Components/Reviews/ReviewsList";
import Settings from "@Components/FileManager/Settings";
import { downloadFile } from "@Services/fileDownload";
import FileDelete from "@Components/FileManager/FileDelete/FileDelete";
import ExcelImport from "@Components/ExcelImport/ExcelImport";
import { excelImportSources } from "@Components/ExcelImport/ExcelHelper";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import TextBoxComponent from "@CubeComponents/form/TextBoxComponent";
import Text from "@CubeComponents/html/Text/Text";
import CreateTransmittal from "@Pages/Transmitals/CreateTransmittal/CreateTransmittal";
import { convertDate } from "@Services/luxonHelper";
import { createRoot } from "react-dom/client";
import { getFileIcon, getIconbasedOnResourceType, isMergeAllowed } from "@CubeComponents/constants/globalFunctions";
import ToolTipComponent from "@CubeComponents/html/tooltip";
import FileConversionStatus from "@Components/FileManager/FileConversionStatus";
import CreateReviewModal from "@Components/Reviews/CreateReviewModal";
import { formCategories } from "@Helpers/constants";
import useFormValidator from "@Components/FormValidation/useFormValidator";
import { NomenclatureField } from "../../services/utils/useCustomFields";
import FormPreview from "@Components/PortalSetings/Configuration/FormsAndFields/FormTemplate/formPreview";
import { DropDownListComponent as DropDownDefaultComponent } from "@syncfusion/ej2-react-dropdowns";
import { fileFormatNotSupportedToast, UnnamedEstimateNotSupportedToast } from "@Actions/GlobalSearchAction";
import FileManagerAsPopup from "./FileManagerAsPopup";
import "./FileManagerNew.css";
import {
  setIsFileVersionUploading,
  setCurrentFileUploadProperties,
  setFileUploadProperties,
  maximiseFileUpload,
  closeFileUpload,
  setFileUploadData,
  emptyFileUploadData,
} from "../../reducers/minimiseFileUpload";
import FolderSyncTemplate from "./FolderSyncTemplate";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

interface FileManagerProps {
  defaultSelectedTab?: string;
  fileManagerAsPopup?: boolean;
  spaceId: string;
  projectId: string;
  showOnlyMergedFile?: boolean;
  setShowProperties?: any;
  mobileFileManager?: boolean;
  hideExternalSpace?: boolean;
  hideReviews?: boolean;
  hideAllTabs?: boolean;
  enableSpaceListDropdown?: boolean;
  openThisSpaceByDefault?: boolean;
  createShortcut?: boolean;
  showFolderTree?: boolean;
  handleFileSelectionCallback?: (files: any[]) => void;
  hideIssues?: boolean;
  hideTasks?: boolean;
  hideEstimates?: boolean;
  hideClashTests?: boolean;
  hideContracts?: boolean;
  hideSchedules?: boolean;
  useAttachedExternalVolume?: boolean;
  hideMergeFiles?: boolean;
  disableContextMenu?: boolean;
  disableFiles?: any[];
  enableOnlyShareableResources?: boolean;
  hideUpload?: boolean;
  enableFilesTypes?: string[] | null;
  handleFolderSelectionCallback?: (folder: any) => void;
  setSpaceId?: (id: any) => void;
  alreadySelected?: any[] | null;
  showExcelImport?: boolean;
  defaultPath?: string;
  allowFolderSelectionCallback?: boolean;
  spaceList?: any[];
}

const FileManager: React.FC<FileManagerProps> = ({
  defaultSelectedTab = "this",
  fileManagerAsPopup = false,
  spaceId,
  projectId,
  showOnlyMergedFile = false,
  setShowProperties,
  mobileFileManager = false,
  hideExternalSpace = false,
  hideReviews = false,
  hideAllTabs = false,
  enableSpaceListDropdown = false,
  openThisSpaceByDefault = false,
  createShortcut = false,
  showFolderTree = true,
  handleFileSelectionCallback = () => {},
  hideIssues = false,
  hideTasks = false,
  hideEstimates = false,
  hideClashTests = false,
  hideContracts = false,
  hideSchedules = false,
  useAttachedExternalVolume = false,
  hideMergeFiles = false,
  disableContextMenu = false,
  disableFiles = [],
  enableOnlyShareableResources = false,
  hideUpload = false,
  enableFilesTypes = null,
  handleFolderSelectionCallback = () => {},
  allowFolderSelectionCallback = false,
  setSpaceId = () => {},
  alreadySelected = null,
  showExcelImport = true,
  defaultPath,
  spaceList,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const fileManagerRef = useRef<any>(null);
  const formTemplateRef = useRef<any>({ current: {} });
  const formValidator: any = useFormValidator({});
  const fileUploadListRef = useRef<any>({ current: [] });
  const location = useLocation();
  const nomenclatureRef = useRef<any[]>([]);
  const spaceListRef = useRef<any>(null);
  const TAB_THIS_SPACE = "this";
  const TAB_EXTERNAL_SPACE = "external";
  const TAB_REVIEWS = "reviews";
  const TAB_SETTINGS = "settings";
  const [fileManagerData, setFileManagerData] = useState<any>({
    cwd: {},
    files: [],
  });
  const [showContainerImportModal, setShowContainerImportModal] = useState<boolean>(false);
  const [openRenameModal, setOpenRenameModal] = useState<any>(false);
  const [selectedFile, setSelectedFile] = useState<any>({});
  const [newName, setNewName] = useState<any>(null);
  const [folderName, setFolderName] = useState<string | null>(null);
  const [createReviewModal, setCreateReviewModal] = useState<any>({ show: false });
  const [fileAllowedExtensions, setFileAllowedExtensions] = useState<any>({});
  const [openMergeModal, setOpenMergeModal] = useState<boolean>(false);
  const [openMergeEstimateModal, setOpenMergeEstimateModal] = useState<boolean>(false);
  const [emptyThisSpace, setEmptyThisSpace] = useState<boolean>(false);
  const [emptyExternal, setEmptyExternal] = useState<boolean>(false);
  const [openFolderCreationModal, setOpenFolderCreationModal] = useState<boolean>(false);
  const [openFileImport, setOpenFileImport] = useState<boolean>(false);
  const [openContainerModal, setOpenContainerModal] = useState<boolean>(false);
  const [currentFolder, setCurrentFolder] = useState<any>({ id: "0" });
  const [selectedFilesToDelete, setSelectedFilesToDelete] = useState<any>(null);
  const [openDeleteConfirmationModal, setOpenDeleteConfirmationModal] = useState<boolean>(false);
  const [openCreateTransmittalModal, setOpenCreateTransmittalModal] = useState<boolean>(false);
  const [filesToCopy, setFilesToCopy] = useState<any>(null);
  const [filesToCut, setFilesToCut] = useState<any>(null);
  const [formTemplateReceived, setFormTemplateReceived] = useState<any>({});
  const [openModalForTransmittalFile, setOpenModalForTransmittalFile] = useState<boolean>(false);
  const [sharingData, setSharingData] = useState<any[]>([]);
  const [containerFormTemplate, setContainerFormTemplate] = useState<any[]>([]);
  const [fileTypeValue, setFileTypeValue] = useState<any>(null);
  const [resourceType, setResourceType] = useState<any>({});
  const [containerName, setContainerName] = useState<string>("");
  const [draggedFiles, setDraggedFiles] = useState<any>([]);
  const [path, setPath] = useState<any>(null);
  const [toolBarBtnState, setToolBarBtnState] = useState<any>({
    upload: !hideUpload,
    refresh: true,
    rename: false,
    delete: false,
    download: false,
    details: true,
    createNewShortcut: false,
    consume: false,
  });
  const [selectedTab, setSelectedTab] = useState<any>(defaultSelectedTab || TAB_THIS_SPACE);
  const [openLink, setOpenLink] = useState<boolean>(false);
  const [shortCutData, setShortCutData] = useState<any>({});
  const [openFileModalExternal, setOpenFileModalExternal] = useState<any>(false);
  const {
    layout,
    getSpaceToggle,
    projectData,
    userDetails,
    fileUploadList,
    isFileVersionUploading,
    fileUploadState,
    filesSelectedToMerge,
    filesSharedUnderResources,
    fileVersions,
    spaceData,
    refreshFileManager,
  }: any = useSelector((state: any) => state);
  const searchParams = new URLSearchParams(location.search);
  const dispatch = useDispatch<any>();
  const pollingRef = useRef<any>(null);
  const spaceType = searchParams.get("spaceType");
  const handleDeleteClick = (selectedFiles: any[]) => {
    let isUserAllowedToDeleteAllFiles = true;
    for (const eachObj of selectedFiles) {
      if (!eachObj.permission.FOLDER_DELETE) {
        isUserAllowedToDeleteAllFiles = false;
      }
    }
    if (isUserAllowedToDeleteAllFiles) {
      setSelectedFilesToDelete(selectedFiles);
      setOpenDeleteConfirmationModal(true);
    } else {
      showToast();
    }
  };

  const handleDeleteModalClose = () => {
    setOpenDeleteConfirmationModal(false);
    setSelectedFilesToDelete(null);
  };

  const handleDeleteSuccess = (status: boolean) => {
    if (status) {
      handleDeleteModalClose();
      const deletedIds = selectedFilesToDelete.map((file: any) => file.id);
      if (deletedIds.length === fileManagerData.files?.length) {
        setEmptyExternal(selectedTab == TAB_EXTERNAL_SPACE);
        setEmptyThisSpace(selectedTab == TAB_THIS_SPACE);
      }
      setFileManagerData((prev: any) => ({
        ...prev,
        files: prev.files?.filter((file: any) => !deletedIds.includes(file.id)),
        filteredFiles: prev.filteredFiles
          ? prev.filteredFiles.filter((file: any) => !deletedIds.includes(file.id))
          : null,
      }));
      setSelectedFilesToDelete(null);
      dispatch(
        showToastNotification({
          content: t("File deleted successfully."),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
    }
  };

  const handleRenameFile = (selectedFiles: any[]) => {
    const file = selectedFiles[0] ?? getSelectedFilesInFileManager()[0];
    if (!file.permission.write) {
      showToast();
    } else {
      setNewName(file.name);
      setOpenRenameModal(file.name);
      setSelectedFile(file);
    }
  };

  const handleFileTransmit = (selectedFiles: any[]) => {
    const allFilesHaveSharePermission = selectedFiles.every((file: any) => file.permission.FOLDER_SHARE);
    if (allFilesHaveSharePermission) {
      setSelectedFile(selectedFiles);
      setOpenCreateTransmittalModal(true);
    } else {
      showToast();
    }
  };

  const fetchConstituentFilesOfMergedFile = async (fileVersion: any) => {
    const mergedFile: any = await axiosWrapper.post(`${getBackendUrl()}/fileOperations/getFileVersionData`, {
      fileVersionId: fileVersion,
    });
    const getConstituentFilesOfMergedFile = mergedFile.data.data.sourceFileVersionId;
    if (getConstituentFilesOfMergedFile.length === 0) {
      dispatch(
        showToastNotification({
          content: t("This merged file does not contain any files. Kindly add files to view."),
          type: TOAST_TYPE_WARNING,
        }),
      );
      return false;
    }
    return true;
  };

  const handleOpenOrPreloadAndOpen = async (selectedFiles: any[], id: string) => {
    if (id === "open" && ["kanban"].includes(selectedFiles[0].resourceType)) {
      handleLocationOpen("/kanban");
    }
    if (
      ["RESOURCE_TYPE_MERGED_FILE", "RESOURCE_TYPE_FILE", "RESOURCE_TYPE_ISSUE", "RESOURCE_TYPE_EMBED"].includes(
        selectedFiles[0].resourceType,
      )
    ) {
      if (selectedFiles[0].resourceType === "RESOURCE_TYPE_MERGED_FILE") {
        const result = await fetchConstituentFilesOfMergedFile(selectedFiles[0].fileVersion);
        if (!result) {
          return;
        }
      }
      if (selectedFiles[0].resourceType === "RESOURCE_TYPE_ISSUE") {
        const location: any = getViewerUrl({
          fileVersionId: selectedFiles[0].fileId,
          issueId: selectedFiles[0].snapshot.issueId,
          projectId,
        });
        handleLocationOpen(location);
        return;
      }
      if (selectedFiles[0].transmittalVersionId) {
        dispatch(
          getResourcesUnderWhichFilesShared({
            resourceType: filesSelectedToMerge[0].resourceType,
            fileId: filesSelectedToMerge[0].hierarchyId,
          }),
        );
        dispatch(
          getFileVersions({
            resourceType: filesSelectedToMerge[0].resourceType,
            fileId: filesSelectedToMerge[0].hierarchyId,
          }),
        );
        setOpenLink(true);
        return;
      }

      const fileId = selectedFiles[0].fileVersion;
      const location: any = getViewerUrl({
        fileVersionId: fileId,
        spaceId,
        projectId,
        preloadAndOpen: id === "preloadAndOpen",
      });
      if (selectedFiles[0].permission.read) {
        handleLocationOpen(location);
      } else {
        showToast();
      }
    }
  };

  const handleDownloadFile = (selectedFiles: any[]) => {
    if (searchParams.get("spaceType") === TAB_THIS_SPACE) {
      const files = selectedFiles;
      const fileVersionIds: any[] = [];
      const folderIds: any[] = [];
      files.forEach((item: any) => {
        const fileExtension = item.name.split(".").pop();
        item.isFile ? fileVersionIds.push(item.fileVersion) : folderIds.push(item._id);
        if (fileExtension === PDF_TYPE[0]) {
          return;
        }
      });
      downloadFile({
        fileVersionIds,
        folderIds,
        type: "Download",
        mobileFileManager,
        fileName: _.get(files, "[0].name"),
      });
    } else {
      showToast();
    }
  };

  const beforeSending = (args: any) => {
    const setVisibilityFlags = () => {
      if (hideIssues) args.hideIssues = true;
      if (hideTasks) args.hideTasks = true;
      if (hideEstimates) args.hideEstimates = true;
      if (hideClashTests) args.hideClashTests = true;
      if (hideSchedules) args.hideSchedules = true;
      if (hideContracts) args.hideContracts = true;
      if (hideMergeFiles) args.hideMergeFiles = true;
      if (useAttachedExternalVolume) args.useAttachedExternalVolume = true;
      args.showOnlyMergedFile = !!showOnlyMergedFile;
    };

    const ensureDataArray = () => {
      if (Array.isArray(args.data) && args.data.length) {
        args.data = args.data.map((d: any) => ({ ...d, spaceId, spaceType: selectedTab }));
        return;
      }
      args.data = [{ spaceId, spaceType: selectedTab }];
    };

    const isFileItem = (name: string) => name?.includes(".");

    const handleUpload = () => {
      const sortFilesList: any[] = Object.values(args.files || {});
      if (!sortFilesList.length) {
        args.cancel = true;
        return;
      }

      const firstIsFile = isFileItem(sortFilesList[0]?.name);
      if (!firstIsFile) {
        dispatch(showToastNotification({ content: t("Folder cannot be dragged"), type: TOAST_TYPE_ERROR }));
        args.cancel = true;
        return;
      }

      // only proceed if every item looks like a file (not folder)
      const notContainFolder = sortFilesList.some((f: any) => isFileItem(f?.name));
      if (!notContainFolder) {
        args.cancel = true;
        return;
      }

      setDraggedFiles(sortFilesList);

      if (fileUploadState === "MINIMISED") {
        dispatch(
          showToastNotification({
            content: t("Please close other upload operations before proceeding!"),
            type: TOAST_TYPE_ERROR,
          }),
        );
        args.cancel = true;
        return;
      }

      dispatch(maximiseFileUpload());
      dispatch(
        setCurrentFileUploadProperties({
          formTemplate: formTemplateRef.current,
          currentFolderRef: currentFolder,
          isUploadAllowed: getPermission(),
          fileNomenclature: _.get(currentFolder, "fileNomenclature"),
          workspaceId: spaceId,
          hierarchyId: currentFolder.hierarchyId,
        }),
      );

      const currentFiles = fileManagerData?.files?.filter((f: any) => f.parentId == currentFolder.id) || [];
      const processed = processFileList({
        fileList: [...sortFilesList],
        currentFiles,
        fileNomenclature: _.get(currentFolder, "fileNomenclature"),
        isFileVersionUploading,
        uploadFolderData: {},
        uploadSpaceId: spaceId,
        selectedSpaceTypeInFileManager: searchParams.get("spaceType"),
        currentFolder,
      });

      dispatch(setFileUploadData(processed));
      args.cancel = true;
    };

    const handleCopy = () => {
      args.targetData.spaceId ||= spaceId;

      const invalid = !Array.isArray(args.data) || args.data.some((obj: any) => !Object.hasOwn(obj, "fileVersion"));

      if (invalid) {
        args.cancel = true;
        dispatch(showToastNotification({ content: SOMETHING_WENT_WRONG, type: TOAST_TYPE_ERROR }));
      }
    };

    switch (args.action) {
      case "upload":
        handleUpload();
        return;
      case "copy":
        handleCopy();
        break;
      case "read":
        setDraggedFiles(null);
        break;
      default:
        break;
    }

    ensureDataArray();
    setVisibilityFlags();
  };

  const handleResourceCut = (selectedFiles: any[]) => {
    setFilesToCut(selectedFiles);
    setFilesToCopy(null);
  };

  const handleResourceCopy = (selectedFiles: any[]) => {
    setFilesToCopy(selectedFiles);
    setFilesToCut(null);
  };

  const handleResourcePaste = async (selectedFolder: any = null) => {
    if (selectedFolder && selectedFolder.length > 1) {
      dispatch(
        showToastNotification({
          content: t("Select one folder to paste content to"),
          type: TOAST_TYPE_WARNING,
        }),
      );
      return;
    }
    if (!filesToCopy && !filesToCut) {
      dispatch(
        showToastNotification({
          content: t("No resource selected to paste"),
          type: TOAST_TYPE_WARNING,
        }),
      );
      return;
    }
    const destinationFolder = selectedFolder[0] ?? currentFolder;
    const destinationFolderId = destinationFolder.id;
    let newFiles = _.cloneDeep(fileManagerData.files);
    let actionFiles: any;
    if (filesToCopy) {
      actionFiles = filesToCopy;
      const copiedFiles = filesToCopy.map((file: any) => ({ ...file, parentId: destinationFolderId }));
      newFiles = [...newFiles, ...copiedFiles];
    } else if (filesToCut) {
      actionFiles = filesToCut;
      const fileIds = filesToCut.map((file: any) => file.id);
      newFiles = newFiles.map((f: any) => {
        if (fileIds.includes(f.id)) {
          f.parentId = destinationFolderId;
        }
        return f;
      });
    }
    if (actionFiles) {
      const allParams: any = {
        action: filesToCopy ? "copy" : "move",
        data: actionFiles,
        targetData: destinationFolder,
        renameFiles: [],
      };
      beforeSending(allParams);
      if (!allParams.cancel) {
        fileManagerRef.current.showLoading();
        const res: any = await axiosWrapper.post(`${getBackendUrl()}/fileSystemServer/`, {
          ...allParams,
        });

        if (!res.data.status) {
          dispatch(
            showToastNotification({
              content: res.data?.errorMessage || res.data?.error?.code || t("Something went wrong"),
              type: TOAST_TYPE_ERROR,
            }),
          );
        } else {
          newFiles = newFiles.map((folder: any) => {
            const isFolder = actionFiles.find((resource: any) => resource.resourceType == "RESOURCE_TYPE_FOLDER");
            if (folder.id == destinationFolderId && isFolder) {
              folder.hasChild = true;
            }
            return folder;
          });
          setFileManagerData((prev: any) => ({ ...prev, files: newFiles }));
        }
        fileManagerRef.current.hideLoading();
        setFilesToCopy(null);
        setFilesToCut(null);
      }
    }
  };

  const handleSelectAllOption = () => {
    const getCondition = (file: any) => {
      if (!currentFolder.resourceType || currentFolder.resourceType == "RESOURCE_TYPE_TRANSMITTAL") {
        return file.transmittalVersionId == currentFolder.id;
      } else if (currentFolder.resourceType == "RESOURCE_TYPE_FOLDER") {
        return file.parentId == currentFolder.id;
      }
      return false;
    };
    const currentFiles = fileManagerData.files?.filter((file: any) => getCondition(file));
    const allRowIndexes = [...Array(currentFiles.length).keys()];
    fileManagerRef.current.setSelectedRows(allRowIndexes);
  };

  const handleUnSelectAllOption = () => {
    fileManagerRef.current.setSelectedRows([]);
  };

  const reloadFileManager = () => {
    if (fileManagerRef.current) {
      fileManagerRef.current?.refreshFileManager();
    }
  };

  const refreshCurrentFolder = () => {
    if (fileManagerRef.current) {
      fileManagerRef.current?.refreshFiles();
    }
  };

  const fileManagerOptionsMapper: any = {
    [TAB_THIS_SPACE]: {
      layoutOptions: [
        {
          id: "refresh",
          name: "Refresh",
          icon: "refresh",
          onClick: refreshCurrentFolder,
        },
        {
          id: "paste",
          name: "Paste",
          icon: "Duplicate",
          onClick: handleResourcePaste,
        },
        {
          id: "selectAll",
          name: "Select All",
          icon: "selectAll",
          onClick: handleSelectAllOption,
        },
        {
          id: "unSelectAll",
          name: "Un-Select All",
          icon: "unSelectAll",
          onClick: handleUnSelectAllOption,
        },
      ],
      fileOptions: [
        {
          id: "open",
          name: "Open",
          icon: "folder",
          onClick: (selectedFiles: any[]) => handleOpenOrPreloadAndOpen(selectedFiles, "open"),
        },
        {
          id: "preloadAndOpen",
          name: "Preload & Open",
          icon: "folder",
          onClick: (selectedFiles: any[]) => handleOpenOrPreloadAndOpen(selectedFiles, "preloadAndOpen"),
        },
        {
          id: "delete",
          name: "Delete",
          icon: "delete",
          onClick: handleDeleteClick,
        },
        {
          id: "download",
          name: "Download",
          icon: "download",
          onClick: handleDownloadFile,
        },
        {
          id: "rename",
          name: "Rename",
          icon: "editProfile",
          onClick: handleRenameFile,
        },
        {
          id: "cut",
          name: "Cut",
          icon: "cut",
          onClick: handleResourceCut,
        },
        {
          id: "copy",
          name: "Copy",
          icon: "copy",
          onClick: handleResourceCopy,
        },
        {
          id: "transmit",
          name: "Transmit",
          icon: "Transmittals",
          onClick: handleFileTransmit,
        },
        {
          id: "CreateReview",
          name: "Create a Review",
          icon: "Review",
          onClick: () => setCreateReviewModal({ show: true }),
        },
      ],
      folderOptions: [
        {
          id: "open",
          name: "Open",
          icon: "folder",
          onClick: (selectedFiles: any[]) => handleOpenOrPreloadAndOpen(selectedFiles, "open"),
        },
        {
          id: "delete",
          name: "Delete",
          icon: "delete",
          onClick: handleDeleteClick,
        },
        {
          id: "download",
          name: "Download",
          icon: "download",
          onClick: handleDownloadFile,
        },
        {
          id: "rename",
          name: "Rename",
          icon: "editProfile",
          onClick: handleRenameFile,
        },
        {
          id: "cut",
          name: "Cut",
          icon: "cut",
          onClick: handleResourceCut,
        },
        {
          id: "paste",
          name: "Paste",
          icon: "Duplicate",
          onClick: handleResourcePaste,
        },
      ],
    },
    [TAB_EXTERNAL_SPACE]: {
      layoutOptions: [
        {
          id: "refresh",
          name: "Refresh",
          icon: "refresh",
          onClick: refreshCurrentFolder,
        },
        {
          id: "selectAll",
          name: "Select All",
          icon: "selectAll",
          onClick: handleSelectAllOption,
        },
        {
          id: "unSelectAll",
          name: "Un-Select All",
          icon: "unSelectAll",
          onClick: handleUnSelectAllOption,
        },
      ],
      fileOptions: [
        {
          id: "open",
          name: "Open",
          icon: "folder",
          onClick: (selectedFiles: any[]) => handleOpenOrPreloadAndOpen(selectedFiles, "open"),
        },
        {
          id: "createNewShortcut",
          name: t("Create new shortcut"),
          icon: "shortcut",
          onClick: (selectedFiles: any[]) => {
            if (selectedFiles[0].folderType == 0) {
              setShortCutData({
                transmittalId: selectedFiles[0].transmittalVersionId,
                fileVersionIds: selectedFiles.map((x: any) => x.fileVersion),
              });
              setOpenFileModalExternal("shortcut");
            }
          },
        },
        {
          id: "consume",
          name: t("Consume"),
          icon: "consume",
          onClick: (selectedFiles: any[]) => {
            setOpenFileModalExternal("consume");
            setShortCutData(selectedFiles);
          },
        },
      ],
      folderOptions: [
        {
          id: "open",
          name: t("Open"),
          icon: "folder",
          onClick: (selectedFiles: any[]) => handleOpenOrPreloadAndOpen(selectedFiles, "open"),
        },
      ],
    },
    reviews: {
      layoutOptions: [],
      fileOptions: [],
      folderOptions: [],
    },
  };

  const dropDownButtonItems: any[] = [
    { text: t("Upload File"), id: "fileUpload", iconCss: "e-upload-file", iconName: "uploadFile" },
    { text: t("Upload Folder"), id: "folderUpload", iconCss: "e-upload-folder", iconName: "uploadFolder" },
    { seperator: true, id: "seperator1" },
    { text: t("New Folder"), id: "newFolder", iconCss: "e-new-folder", iconName: "newFolder" },
    { seperator: true, id: "seperator2" },
    { text: t("Merge"), id: "merge", iconCss: "e-new-merge", iconName: "merge" },
    { text: t("Container"), id: "container", iconCss: "e-new-container", iconName: "container" },
  ];

  if (showExcelImport) {
    dropDownButtonItems.push({
      text: t("Import from Excel"),
      id: "importExcel",
      iconCss: "e-new-importExcel",
      iconName: "ImportExcel",
    });
  }
  if (layout.ATTACHED_EXTERNAL_VOLUME) {
    dropDownButtonItems.push({
      text: t("Import"),
      id: "fileImport",
      iconCss: "e-upload-file",
      iconName: "uploadFile",
    });
  }

  useEffect(() => {
    return () => {
      if (pollingRef.current) {
        clearTimeout(pollingRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (spaceType) {
      setSelectedTab(spaceType);
    }
  }, [spaceType]);

  useEffect(() => {
    if (!defaultPath) {
      setPath("/");
    } else {
      setPath(defaultPath);
    }
  }, [defaultPath]);

  useEffect(() => {
    document.title = `Files | ${projectData?.description}`;
  }, [projectData]);

  useEffect(() => {
    if (refreshFileManager) {
      dispatch(refreshFileManagerFn(false));
      refreshCurrentFolder();
    }
    return () => {
      dispatch(refreshFileManagerFn(false));
    };
  }, [refreshFileManager]);

  useEffect(() => {
    if (
      filesSelectedToMerge?.[0]?.hierarchyId &&
      filesSharedUnderResources?.[filesSelectedToMerge[0]?.hierarchyId] &&
      fileVersions?.[filesSelectedToMerge[0]?.hierarchyId] &&
      openLink
    ) {
      const transmittals = Object.values(filesSharedUnderResources[filesSelectedToMerge[0].hierarchyId]);
      let sharingData: any[] = [];

      transmittals.forEach((val: any) => {
        const toSpaceDetails = val.TRANSMITTAL_TOSPACEIDS;

        if (toSpaceDetails.value == spaceId) {
          let allFileVersion: any[] = [];

          if (fileVersions[filesSelectedToMerge[0].hierarchyId].length) {
            allFileVersion = fileVersions[filesSelectedToMerge[0].hierarchyId].map((val: any) => val.id);
          }

          val.TRANSMITTAL_FILEIDS.forEach((file: any) => {
            const fromUserDetails = val.TRANSMITTAL_FROMUSER;
            if (allFileVersion.includes(file.value)) {
              sharingData.push({
                updatedDate: val.TRANSMITTAL_TOSPACEIDS.createdDate,
                fromUser: `${fromUserDetails.firstName} ${fromUserDetails.lastName}`,
                metadata: {
                  size: JSON.parse(file.metadata).size,
                },
                id: file.value,
                awsFileName: file.awsFileName,
                fileName: file.name,
                transmittalVersionId: val.TRANSMITTAL_DETAILS.transmittalVersionId,
                fileVersionNumber: file.fileVersionNumber,
                transmittalNo: val.TRANSMITTAL_COUNTER.value,
              });
            }
          });
        }
      });
      sharingData = sharingData.sort((a: any, b: any) => b.updatedDate - a.updatedDate);

      if (sharingData[0] && filesSelectedToMerge[0].fileVersion != sharingData[0].id) {
        setOpenLink(false);
        setOpenModalForTransmittalFile(true);
        setSharingData(sharingData);
      } else {
        openCurrentFileVersionInTransmittal();
      }
    }
  }, [filesSelectedToMerge, filesSharedUnderResources, fileVersions, openLink]);

  useEffect(() => {
    getFormTemplate();
    dispatch(setCurrentFolderInFileManager(currentFolder));
    if (!fileManagerAsPopup && currentFolder?.id != "0") {
      const innerPath = currentFolder.parentIdArray?.filter((id: any) => id != "0").join("/");
      const initialPath = innerPath ? `/${innerPath}` : "";
      let folderPath = `${initialPath}/${currentFolder.id}/`;
      const encodedFolderPath = encodeURIComponent(folderPath);
      navigate(`${location.pathname}${location.search}#folderPath=${encodedFolderPath}`, { replace: true });
    } else if (!fileManagerAsPopup && currentFolder?.id == "0") {
      navigate(`${location.pathname}${location.search}`, { replace: true });
    }
  }, [currentFolder]);

  useEffect(() => {
    if (fileUploadState == "CLOSED") {
      dispatch(setIsFileVersionUploading(false));
      dispatch(closeFileUpload());
      dispatch(emptyFileUploadData());
    }
  }, [fileUploadState]);

  useEffect(() => {
    fileUploadListRef.current = [...fileUploadList];
  }, [fileUploadList]);

  useEffect(() => {
    if (fileUploadList.length) {
      dispatch(minimiseFileUpload());
    } else {
      dispatch(closeFileUpload());
    }
  }, [location]);

  useEffect(() => {
    setFileAllowedExtensions({
      minFileSize: 0,
      maxFileSize: MAX_FILE_UPLOAD_SIZE,
      allowedExtensions: "",
    });
  }, []);

  useEffect(() => {
    if (openThisSpaceByDefault || createShortcut) {
      setSelectedTab(TAB_THIS_SPACE);
    }
    return () => {
      if (typeof handleFileSelectionCallback === "function") {
        handleFileSelectionCallback([]);
      }
      if (!fileManagerAsPopup) {
        dispatch(emptyCurrentFolderInFileManager());
      }
    };
  }, []);

  useEffect(() => {
    reloadFileManager();
    setToolBarBtnState((prev: any) => ({
      ...prev,
      upload: selectedTab == TAB_THIS_SPACE && !hideUpload,
      refresh: selectedTab == TAB_THIS_SPACE || selectedTab == TAB_EXTERNAL_SPACE,
      rename: prev.rename && selectedTab == TAB_THIS_SPACE,
      delete: prev.delete && selectedTab == TAB_THIS_SPACE,
      download: prev.download && selectedTab == TAB_THIS_SPACE,
      details: selectedTab == TAB_THIS_SPACE || selectedTab == TAB_EXTERNAL_SPACE,
      consume: prev.consume && selectedTab == TAB_EXTERNAL_SPACE,
      createNewShortcut: prev.createNewShortcut && selectedTab == TAB_EXTERNAL_SPACE,
    }));
  }, [selectedTab]);

  useEffect(() => {
    if (Array.isArray(alreadySelected) && fileManagerRef.current) {
      const currentFiles = fileManagerData.files?.filter((file: any) => file.parentId == currentFolder.id);
      const selectTheseRows: number[] = [];
      alreadySelected.forEach((file: any) => {
        const indexOfItem = currentFiles.findIndex((x: any) => x.hierarchyId == file.hierarchyId);
        if (!isNaN(indexOfItem) && indexOfItem != -1) {
          selectTheseRows.push(indexOfItem);
        }
      });
      fileManagerRef.current?.setSelectedRows(selectTheseRows);
    }
  }, [fileManagerRef.current]);

  const closeReviewModal = () => {
    setCreateReviewModal({ show: false });
  };

  const handleLocationOpen = (location: string, args?: any) => {
    if (!fileManagerAsPopup) {
      if (_.get(args, "resourceType") && _.get(args, "resourceType") != "RESOURCE_TYPE_FOLDER" && mobileFileManager) {
        (window as any)?.ReactNativeWebView?.postMessage(JSON.stringify({ action: "disableFileOpen", location }));
      } else {
        navigate(location);
      }
    }
  };

  const showToast = () => {
    dispatch(
      showToastNotification({
        content: t("Insufficient permission to perform this action."),
        type: TOAST_TYPE_ERROR,
      }),
    );
  };

  const handleFileManagerTabClick = (type: string) => {
    if ([TAB_THIS_SPACE, TAB_EXTERNAL_SPACE].includes(type)) {
      dispatch(setCurrentPath("/"));
    }
    if ([TAB_EXTERNAL_SPACE, TAB_REVIEWS].includes(type) && !fileManagerAsPopup) {
      setShowProperties(false);
    }
    if (selectedTab == type) {
      return false;
    }

    setSelectedTab(type);

    const searchParams = new URLSearchParams(location.search);
    searchParams.set("spaceType", type);
    if (!fileManagerAsPopup) {
      handleLocationOpen(`${location.pathname}?${searchParams.toString()}`);
    }
  };

  const handleSpaceSelect = (args: any) => {
    if (args.isInteracted) {
      setSpaceId(args.value);
    }
  };

  useEffect(() => {
    if (spaceList?.length && !spaceId) {
      spaceListRef.current.value = spaceList[0].id;
      setSpaceId(spaceList?.[0]?.id);
    }
  }, [spaceList]);

  useEffect(() => {
    if (spaceId) {
      dispatch(setSpaceToggle({ spaceId }));
      reloadFileManager();
    }
  }, [spaceId]);

  const handleSpaceToggle = async (event: any) => {
    dispatch(
      setSpaceToggle({
        spaceId,
        toggle: event.target.checked,
      }),
    );
    if (fileManagerRef.current) {
      refreshCurrentFolder();
    }
  };

  const getSelectedFilesInFileManager = () => {
    return fileManagerRef.current.getSelectedFilesInFileManager() || [];
  };
  const handleDetailIconClick = () => {
    const selectedFile = getSelectedFilesInFileManager();

    if (mobileFileManager) {
      (window as any)?.ReactNativeWebView?.postMessage(
        JSON.stringify({
          action: "properties",
          data: selectedFile[0],
        }),
      );
    } else if (setShowProperties) {
      setShowProperties((prev: any) => !prev);
    }
  };

  function getPermission() {
    const value = currentFolder || {};
    if (Object.hasOwn(value, "permission")) {
      return value.permission.upload;
    }
    return false;
  }

  const getFormTemplate = async () => {
    if (currentFolder.hierarchyId) {
      const response: any = await axiosWrapper.post(`${getBackendUrl()}/projects/getFormTemplate`, {
        projectId,
        hierarchyId: currentFolder.hierarchyId,
        resourceType: formCategories.files,
      });

      if (response.data.status && response.data.data) {
        const template = response.data?.data?.template || [];
        setContainerFormTemplate(template);
        formTemplateRef.current = {
          template,
          formTemplateId: response.data.data._id,
        };
      }
      setFormTemplateReceived((prev: any) => ({
        ...prev,
        [currentFolder.hierarchyId]: true,
      }));
    }
  };

  const handleFileAndFolderUpload = (args: any) => {
    setFormTemplateReceived(false);
    if (fileUploadState == "CLOSED") {
      dispatch(emptyFileUploadData());
    }
    if (
      !fileUploadListRef.current.length ||
      (fileUploadListRef.current[0]?.hierarchyId == currentFolder.hierarchyId &&
        fileUploadListRef.current[0]?.spaceId == spaceId)
    ) {
      if (!fileUploadListRef.current.length) {
        getFormTemplate();
      }
      dispatch(
        setFileUploadProperties({
          [`${spaceId}_${currentFolder.hierarchyId}`]: {
            currentFiles: fileManagerData?.files?.filter((file: any) => file.parentId == currentFolder.id) || [],
            workspaceId: spaceId,
            fileNomenclature: _.get(currentFolder, "fileNomenclature", ""),
            isUploadAllowed: getPermission(),
            formTemplate: formTemplateRef.current,
          },
        }),
      );
      dispatch(
        setCurrentFileUploadProperties({
          currentFiles: fileManagerData?.files?.filter((file: any) => file.parentId == currentFolder.id) || [],
          workspaceId: spaceId,
          hierarchyId: currentFolder.hierarchyId,
          selectedSpaceTypeInFileManager: selectedTab,
          fileAllowedExtensions,
          draggedFiles,
          isFolderUpload: args.item.id === "folderUpload",
          fileNomenclature: _.get(currentFolder, "fileNomenclature", ""),
          isUploadAllowed: getPermission(),
          formTemplate: formTemplateRef.current,
          formTemplateReceived,
          fileUploadStateRef: { current: "MAXIMISED" },
          currentFolderRef: currentFolder,
        }),
      );
      dispatch(maximiseFileUpload());
    } else {
      dispatch(
        showToastNotification({
          content: t("Another upload is in progress. Please close that popup to proceed."),
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
  };

  const handleSelectOption = (args: any) => {
    if (["fileUpload", "folderUpload"].includes(args.item.id)) {
      if (args.item.id === "folderUpload" && !currentFolder.permission?.write) {
        showToast();
        return;
      }
      handleFileAndFolderUpload(args);
    } else if (args.item.id == "merge") {
      setOpenMergeModal(true);
    } else if (args.item.id == "newFolder") {
      setOpenFolderCreationModal(true);
    } else if (args.item.id == "container") {
      setOpenContainerModal(true);
    } else if (args.item.id == "fileImport") {
      setOpenFileImport(true);
    } else if (args.item.id == "importExcel") {
      setShowContainerImportModal(true);
    }
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    const permissionCheck = getPermission();
    if (permissionCheck) {
      setAnchorEl(event.currentTarget);
    } else {
      showToast();
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getUploadDropDown = () => {
    const permissionCheck = getPermission();
    return (
      <Box className="border border-button_light rounded">
        <ButtonComponent
          disabled={fileManagerAsPopup}
          onClick={handleClick}
          buttonType={BUTTON_TYPES.ACTIVE_BUTTON}
          endIcon={<KeyboardArrowDownIcon />}
        >
          <span className="flex items-center gap-2">
            <IconComponent className="h-4" name="upload" />
            <Text>{t("New")}</Text>
          </span>
        </ButtonComponent>
        <Menu
          id="fade-menu"
          slotProps={{
            list: {
              "aria-labelledby": "fade-button",
            },
          }}
          slots={{ transition: Fade }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          {dropDownButtonItems.map((item) =>
            item.seperator ? (
              <Divider key={item.id} sx={{ margin: "0px !important" }} />
            ) : (
              <MenuItem
                sx={{ fontSize: "14px", paddingBottom: "8px !important", paddingTop: "8px !important" }}
                key={item.id}
                onClick={(args: any) => {
                  if (isFileVersionUploading) {
                    dispatch(
                      showToastNotification({
                        content: t("Please close other upload operations before proceeding!"),
                        type: TOAST_TYPE_ERROR,
                      }),
                    );
                  } else {
                    if (!permissionCheck) {
                      dispatch(
                        showToastNotification({
                          content: t("Insufficient permission"),
                          type: TOAST_TYPE_ERROR,
                        }),
                      );
                      return;
                    }
                    handleSelectOption({ ...args, item });
                  }
                  handleClose();
                }}
              >
                <span className="flex items-center gap-2">
                  <IconComponent className="h-4" name={item.iconName} />
                  {item.text}
                </span>
              </MenuItem>
            ),
          )}
        </Menu>
      </Box>
    );
  };

  const headerTabs: any[] = [
    {
      id: TAB_THIS_SPACE,
      name: window.location.host.includes("dpmsportal") ? `This ${modulesNameSynonymMapper.space}` : t("This Space"),
      active: selectedTab == TAB_THIS_SPACE,
      onClick: () => handleFileManagerTabClick(TAB_THIS_SPACE),
      align: "left",
      dataTestId: "ThisSpaceTab",
      allow: true,
    },
    {
      id: TAB_EXTERNAL_SPACE,
      name: t("External"),
      active: selectedTab == TAB_EXTERNAL_SPACE,
      onClick: () => handleFileManagerTabClick(TAB_EXTERNAL_SPACE),
      align: "left",
      dataTestId: "ExternalTab",
      allow: layout.TRANSMITTAL?.ENABLE && !hideExternalSpace,
    },
    {
      id: TAB_REVIEWS,
      name: t("Reviews"),
      active: selectedTab == TAB_REVIEWS,
      onClick: () => handleFileManagerTabClick(TAB_REVIEWS),
      align: "left",
      dataTestId: "Reviews",
      allow: !hideReviews,
    },
    {
      allow: enableSpaceListDropdown,
      component: (
        <div>
          <DropDownListComponent
            ref={spaceListRef}
            buttonType={BUTTON_TYPES.DROPDOWN_BACKGROUND_BUTTON}
            fields={{ text: "spaceName", value: "id" }}
            placeholder={t("Select Space")}
            change={handleSpaceSelect}
            dataSource={spaceList}
            query={new Query().addParams("projectId", projectId)}
            popupWidth="273px"
            width="273px"
            value={spaceId}
            noRecordsTemplate="No Spaces Found"
          />
        </div>
      ),
      align: "left",
    },
    {
      allow: process.env.REACT_APP_ENV == "qa" && userDetails?.email != "abdelrahman.abouhadid@macegroup.com",
      align: "right",
      id: "meet",
      name: "Meet",
      dataTestId: "meet",
      icon: "meeting",
      onClick: () => window.open("https://meet.techture.global", "_blank"),
    },
    {
      allow: process.env.REACT_APP_ENV == "qa" && userDetails?.email != "abdelrahman.abouhadid@macegroup.com",
      align: "right",
      id: "chat",
      name: "Chat",
      dataTestId: "chat",
      onClick: () => window.open("https://chat.cube.ms", "_blank"),
      icon: "Chat",
    },
    {
      id: TAB_SETTINGS,
      name: t("Settings"),
      active: selectedTab == TAB_SETTINGS,
      onClick: () => handleFileManagerTabClick(TAB_SETTINGS),
      icon: "SettingsIcon",
      align: "right",
      dataTestId: "SpaceSettings",
      allow: layout.WORKSPACE_SETTINGS?.ENABLE_SPACE_SETTINGS && !fileManagerAsPopup,
    },
    {
      align: "right",
      allow: layout.WORKSPACE_SETTINGS?.ENABLE_HIDDEN_ITEMS_CHECKBOX,
      component: (
        <Box id="toggleExtraDivToFixSwitchComp" className="flex items-center gap-3">
          <ToggleSwitchComponent
            id="toggleBtn"
            checked={getSpaceToggle.toggle}
            onChange={handleSpaceToggle}
            data-testid="SpaceToggleButton"
          />
          <Box data-testid="ShowHiddenItemsText">
            <Text>{t("Show hidden items")}</Text>
          </Box>
        </Box>
      ),
    },
  ];

  const nameTemplate = (args: any) => {
    const container = document.createElement("div");
    container.classList.add("w-full");
    const root = createRoot(container);
    let content: string = "";
    if (!args.isFormTemplateValid) {
      content = t("Form template is invalid.");
    } else if (!args.isFileNomenclatureCorrect) {
      content = t("File name does not comply with File nomenclature set for this Folder. Please rename the file.");
    }
    root.render(
      <div className="flex items-center flex-row gap-1 justify-between name-td">
        <span className="e-fe-text text-ellipsis overflow-hidden whitespace-nowrap">{args.name}</span>
        <div className="flex gap-2">
          {selectedTab == TAB_THIS_SPACE && (
            <>
              {(!args.isFileNomenclatureCorrect || !args.isFormTemplateValid) &&
                args.resourceType !== "RESOURCE_TYPE_TRANSMITTAL" &&
                !args.transmittalVersionId && (
                  <ToolTipComponent showTipPointer position="bottom" content={content}>
                    <IconComponent name={"ErrorIcon"} className="w-4 h-4" />
                  </ToolTipComponent>
                )}
              <FileConversionStatus ref={pollingRef} {...args} />
            </>
          )}
        </div>
      </div>,
    );
    return container;
  };

  const getResourceIcon = (file: any) => {
    const container = document.createElement("div");
    const root = createRoot(container);

    root.render(<div className="flex gap-2 items-center">{getIconbasedOnResourceType(file)}</div>);
    return container;
  };

  const fileColumns: any[] = [
    {
      id: "id",
      field: "id",
      name: "",
      formatter: (data: any, params: any, a: any, b: any, value: any) => getResourceIcon(value),
      minWidth: 50,
    },
    {
      id: "name",
      field: "name",
      name: t("Name"),
      minWidth: 250,
      formatter: (data: any, params: any, a: any, b: any, value: any) => nameTemplate(value),
    },
    {
      id: "dateModified",
      field: "dateModified",
      name: t("Last Modified on"),
      formatter: (data: any, params: any, a: any, b: any, value: any) =>
        convertDate(_.get(value, "dateModified"), "dateForTooltip"),
      minWidth: 150,
    },
    {
      id: "modifiedBy",
      field: "modifiedBy",
      name: t("Last Modified by"),
      minWidth: 150,
    },
    {
      id: "size",
      field: "size",
      name: t("Size"),
      minWidth: 80,
      formatter: (data: any, params: any, a: any, b: any, value: any) =>
        value.size && value.size != "0" ? formatBytes(value.size) : "",
    },
    {
      id: "versionNumber",
      field: "versionNumber",
      name: t("Version"),
      formatter: (data: any, params: any, a: any, b: any, value: any) =>
        value.versionNumber ? `V${value.versionNumber}` : "",
      minWidth: 80,
    },
  ];

  const getToolBarItems = () => {
    let toolbar: any[] = [];
    if (fileManagerAsPopup) {
      toolbar = [
        {
          text: t("Refresh"),
          id: "refresh",
          iconName: "refresh",
          align: "left",
          show: toolBarBtnState.refresh,
        },
      ];
    } else if (selectedTab == TAB_THIS_SPACE) {
      toolbar = [
        {
          text: "Upload",
          id: "upload",
          align: "left",
          show: toolBarBtnState.upload,
          template: getUploadDropDown(),
        },
        {
          text: t("Refresh"),
          id: "refresh",
          iconName: "refresh",
          align: "left",
          show: toolBarBtnState.refresh,
        },
        {
          text: t("Delete"),
          id: "delete",
          iconName: "delete",
          align: "left",
          show: toolBarBtnState.delete,
        },
        {
          text: t("Rename"),
          id: "rename",
          iconName: "edit",
          align: "left",
          show: toolBarBtnState.rename,
        },
        {
          text: t("Download"),
          id: "download",
          iconName: "download",
          align: "left",
          show: toolBarBtnState.download,
        },
        {
          show: toolBarBtnState.details,
          align: "right",
          template: <IconComponent onClick={handleDetailIconClick} name="details" />,
        },
        {
          show: (window as any).electronAPI,
          align: "right",
          template: (
            <FolderSyncTemplate
              spaceId={spaceId}
              projectId={projectId}
              spaceData={spaceData}
              currentFolder={currentFolder}
            />
          ),
        },
      ];
    } else if (selectedTab == TAB_EXTERNAL_SPACE) {
      toolbar = [
        {
          text: t("Refresh"),
          id: "refresh",
          iconName: "refresh",
          align: "left",
          show: toolBarBtnState.refresh,
        },
        {
          text: t("Consume"),
          id: "consume",
          iconName: "consume",
          align: "left",
          show: toolBarBtnState.consume,
        },
        {
          id: "createNewShortcut",
          text: t("Create new shortcut"),
          iconName: "shortcut",
          align: "left",
          show: toolBarBtnState.createNewShortcut,
        },
        {
          show: toolBarBtnState.details,
          align: "right",
          template: <IconComponent onClick={handleDetailIconClick} name="details" />,
        },
      ];
    }
    return toolbar;
  };

  const toolbarItems = getToolBarItems();

  const menuOpen = (selectedFiles: any[] = []) => {
    const searchParams = new URLSearchParams(location.search);
    const disableItems: string[] = [];
    if (searchParams.get("spaceType") !== TAB_EXTERNAL_SPACE) {
      selectedFiles.forEach((fileDetail: any) => {
        if (!fileDetail?.permission?.read) {
          disableItems.push("open");
        }
        if (!fileDetail?.permission?.FOLDER_DELETE) {
          disableItems.push("delete");
        }
        if (
          ![
            "RESOURCE_TYPE_MERGED_FILE",
            "RESOURCE_TYPE_FILE",
            "RESOURCE_TYPE_FOLDER",
            "RESOURCE_TYPE_SHORTCUT_FILE",
          ].includes(fileDetail.resourceType) ||
          !fileDetail?.permission?.download ||
          fileDetail.isEmptyContainer
        ) {
          disableItems.push("download");
        }
        if (!fileDetail?.permission?.write) {
          disableItems.push("rename");
          disableItems.push("cut");
          disableItems.push("newFolder");
        }
        if (!fileDetail?.permission?.upload) {
          disableItems.push("upload");
        }
        if (fileDetail?.hierarchyId == "0") {
          disableItems.push("cut");
        }
        if (
          !DRAWING_TYPE.includes(fileDetail?.name.split(".")[fileDetail?.name.split(".").length - 1]) &&
          fileDetail?.resourceType !== "RESOURCE_TYPE_MERGED_FILE"
        ) {
          disableItems.push("preloadAndOpen");
        }
        if (fileDetail?.isFile) {
          disableItems.push("paste");
          if (fileManagerAsPopup) {
            disableItems.push("open");
            disableItems.push("preloadAndOpen");
          }
        }
        if (!fileDetail?.isFile) {
          disableItems.push("copy");
        }
      });
      if (!filesToCopy && !filesToCut) {
        disableItems.push("paste");
      }
      if (selectedFiles.length > 1) {
        disableItems.push("open");
        disableItems.push("rename");
        disableItems.push("paste");
      }
    }
    if (fileManagerAsPopup) {
      disableItems.push("upload");
      disableItems.push("new");
    }
    const uniqueDisableItems = [...new Set(disableItems)];
    return uniqueDisableItems;
  };

  const getHeaderTabs = () => {
    const leftTabs = headerTabs.filter((t: any) => t.allow && t.align === "left");
    const rightTabs = headerTabs.filter((t: any) => t.allow && t.align === "right");

    return (
      <div className="w-full items-center border-b border-b-button_light">
        <Tabs
          value={selectedTab}
          className="w-full flex gap-5 ps-5 pe-5"
          sx={{
            "& .MuiTabs-flexContainer": {
              gap: "40px",
            },
          }}
        >
          {leftTabs.map(
            (tab: any) =>
              tab.component ?? (
                <Tab
                  key={tab.id}
                  value={tab.id}
                  label={
                    <div className="flex items-center gap-1">
                      {tab.icon && <IconComponent name={tab.icon} />}
                      {tab.name}
                    </div>
                  }
                  onClick={tab.onClick}
                  data-testid={tab.dataTestId}
                />
              ),
          )}
          <span className="flex-1" />
          {rightTabs.map(
            (tab: any) =>
              tab.component ?? (
                <Tab
                  key={tab.id}
                  value={tab.id}
                  label={
                    <div className="flex items-center gap-1">
                      {tab.icon && <IconComponent name={tab.icon} />}
                      {tab.name}
                    </div>
                  }
                  onClick={tab.onClick}
                  data-testid={tab.dataTestId}
                  className={tab.active ? "font-bold" : ""}
                />
              ),
          )}
        </Tabs>
      </div>
    );
  };

  const onFileSelect = (args: any[]) => {
    const fileList = args;
    let fileCount = 0;
    let estimateCount = 0;
    let scheduleCount = 0;
    let contractCount = 0;
    const toolBtnState = {
      rename: fileList.length == 1,
      delete: fileList.length > 0,
      download: fileList.length > 0,
      consume: fileList.length > 0 && fileList[0].resourceType != "RESOURCE_TYPE_TRANSMITTAL",
      createNewShortcut: fileList.length > 0 && fileList[0].resourceType != "RESOURCE_TYPE_TRANSMITTAL",
    };
    fileList.forEach((file: any) => {
      const resourceType = file.resourceType;

      if (resourceType == "RESOURCE_TYPE_ESTIMATE") {
        estimateCount = 1;
      } else if (resourceType == "RESOURCE_TYPE_SCHEDULE") {
        scheduleCount = 1;
      } else if (resourceType == "RESOURCE_TYPE_CONTRACT") {
        contractCount = 1;
      } else {
        if (file.isEmptyContainer) {
          toolBtnState.download = false;
        }
        fileCount = 1;
      }
    });
    if (fileList.length == 0) {
      dispatch(selectedFilesFileManager([]));
    } else if (!fileManagerAsPopup) {
      dispatch(selectedFilesFileManager(args));
    }

    if (fileCount + estimateCount + scheduleCount > 1) {
      toolBtnState.delete = false;
    }
    if (estimateCount || scheduleCount || contractCount) {
      toolBtnState.download = false;
    }

    setToolBarBtnState((prev: any) => ({
      ...prev,
      ...toolBtnState,
    }));

    if (typeof handleFileSelectionCallback === "function") {
      handleFileSelectionCallback(args);
    }
  };

  const isShortcutType = (t: string) =>
    t === "RESOURCE_TYPE_SHORTCUT_FILE" || t === "RESOURCE_TYPE_SHORTCUT_MERGED_FILE";

  const handleDirectNav = (row: any) => {
    switch (row.resourceType) {
      case "RESOURCE_TYPE_ESTIMATE": {
        handleLocationOpen(getEstimateUrl({ projectId, estimateId: row.estimateId }), row);
        return true;
      }
      case "RESOURCE_TYPE_SCHEDULE": {
        handleLocationOpen(getScheduleUrl({ projectId, scheduleId: row.schId, selectedTab: "gantt" }), row);
        return true;
      }
      case "RESOURCE_TYPE_CONTRACT": {
        handleLocationOpen(
          getContractDetailUrl({ projectId, contractId: row.contractId, selectedTab: "details" }),
          row,
        );
        return true;
      }
      default:
        return false;
    }
  };

  const ensureFileEngineOk = (row: any) => {
    if (row.resourceType !== "RESOURCE_TYPE_FILE") return true;
    if (!row.engineType) {
      dispatch(
        showToastNotification({
          content: t("Select an engine to view the file"),
          type: TOAST_TYPE_WARNING,
        }),
      );
      return false;
    }
    if (row.engineType === PDF_ENGINE) {
      dispatch(setViewerState({ isSidebarOpen: false }));
    }
    return true;
  };

  const resolveFileId = (row: any) => {
    if (row.resourceType === "RESOURCE_TYPE_ISSUE") {
      return row.fileVersion || row.fileId;
    }
    if (isShortcutType(row.resourceType)) {
      return row.sourceFileVersionId;
    }
    return row.fileVersion;
  };

  const buildViewerUrl = (row: any, fileId: any, isExternalSpace: boolean) => {
    const base: any = { fileVersionId: fileId, spaceId, projectId, shortcutParentId: row.parentId };
    if (isExternalSpace) base.transmittalVersionId = row.transmittalVersionId;
    if (row.resourceType === "RESOURCE_TYPE_ISSUE") base.issueId = row.issueId;
    return getViewerUrl(base);
  };

  const canOpenViewer = (row: any, isExternalSpace: boolean) =>
    isExternalSpace || row?.permission?.read || row.resourceType !== "RESOURCE_TYPE_FILE";

  const onFileClick = async (clickedRow: any) => {
    if (!clickedRow?.isFile || fileManagerAsPopup) return;

    const params = new URLSearchParams(location.search);
    const isExternalSpace = params.get("spaceType") === TAB_EXTERNAL_SPACE;
    const isThisSpace = params.get("spaceType") === TAB_THIS_SPACE;

    if (handleDirectNav(clickedRow)) return;

    if (clickedRow.resourceType === "RESOURCE_TYPE_MERGED_FILE") {
      const ok = await fetchConstituentFilesOfMergedFile(clickedRow.fileVersion);
      if (!ok) return;
    }

    if (!ensureFileEngineOk(clickedRow)) return;

    const fileId = resolveFileId(clickedRow);
    if (isThisSpace && clickedRow.resourceType === "RESOURCE_TYPE_FILE" && !fileId) {
      dispatch(
        showToastNotification({
          content: t("No file associated to open"),
          type: TOAST_TYPE_WARNING,
        }),
      );
      return;
    }

    const targetUrl: any = buildViewerUrl(clickedRow, fileId, isExternalSpace);

    if (canOpenViewer(clickedRow, isExternalSpace)) {
      handleLocationOpen(targetUrl, clickedRow);
    } else {
      showToast();
    }
  };

  const toolbarClick = (args: any, id: string) => {
    const selectedFiles = getSelectedFilesInFileManager();

    if (id == "refresh") {
      refreshCurrentFolder();
    } else if (id == "delete") {
      handleDeleteClick(selectedFiles);
    } else if (id == "rename") {
      handleRenameFile(selectedFiles);
    } else if (id == "download") {
      handleDownloadFile(selectedFiles);
    } else if (id == "consume") {
      setOpenFileModalExternal("consume");
      setShortCutData(selectedFiles);
    } else if (id == "createNewShortcut") {
      if (selectedFiles[0].folderType == 0) {
        setShortCutData({
          transmittalId: selectedFiles[0].transmittalVersionId,
          fileVersionIds: selectedFiles.map((x: any) => x.fileVersion),
        });
        setOpenFileModalExternal("shortcut");
      }
    }
  };

  const onSuccess = (args: any) => {
    if (args?.result?.cwd?.name != "This Space" && (createShortcut || allowFolderSelectionCallback)) {
      handleFolderSelectionCallback({
        ...args.result.cwd,
        spaceId,
      });
    }

    if (args.result.files?.length == 0) {
      if (selectedTab == TAB_THIS_SPACE && args.result.cwd?.hierarchyId == "0" && args.action != "search") {
        setEmptyThisSpace(true);
      } else if (selectedTab == TAB_EXTERNAL_SPACE && !args.result.cwd?.transmittalVersionId) {
        setEmptyExternal(true);
      }
    } else if (args.result.cwd?.hierarchyId == "0") {
      setEmptyThisSpace(false);
    } else {
      setEmptyExternal(false);
    }
  };

  const saveFileMergeModal = async (listOfSelectedFiles: any, mergeFileName: string) => {
    const sourceFileVersionId = Object.values(listOfSelectedFiles).map((val: any) => {
      if (val.isEmptyContainer) {
        return val.id;
      }
      return val.fileVersion;
    });
    const fileObjArray = Object.values(listOfSelectedFiles);
    const fileSettings: any = isMergeAllowed(fileObjArray);

    const mergeParams: any = {
      sourceFileVersionId,
      originalName: mergeFileName,
      parentId: currentFolder.hierarchyId,
      spaceId,
      folderType: currentFolder.folderType ?? 0,
    };
    if (!fileSettings.mergedAllowed) {
      dispatch(fileFormatNotSupportedToast());
    } else if (fileSettings.isFile) {
      const response: any = await createMergeFile(mergeParams);
      if (response.data.status) {
        if (!fileManagerAsPopup) {
          dispatch(selectedFilesFileManager([]));
        }
        if (typeof handleFileSelectionCallback === "function") {
          handleFileSelectionCallback([]);
        }
        closeFileMergeModal();
        refreshCurrentFolder();
        dispatch(
          showToastNotification({
            content: t("Files merged successfully."),
            type: TOAST_TYPE_SUCCESS,
          }),
        );
      } else {
        dispatch(
          showToastNotification({
            content: response.data.errorMessage,
            type: TOAST_TYPE_WARNING,
          }),
        );
      }
    } else if (!fileSettings.isFile) {
      await createMergeEstimateModal(listOfSelectedFiles, mergeFileName);
    }
  };

  const closeFileMergeModal = () => {
    setOpenMergeModal(false);
  };

  const closeCreateShortcutModal = () => {
    setOpenFileModalExternal(false);
  };

  const closeFileImportPopup = () => {
    setOpenFileImport(false);
  };

  const closeMergeEstimateModal = () => {
    setOpenMergeEstimateModal(false);
  };

  const handleFileImportCallback = async (listOfSelectedFiles: any) => {
    closeFileImportPopup();
    if (Object.keys(listOfSelectedFiles).length) {
      const response: any = await axiosWrapper.post(`${getBackendUrl()}/fileOperations/importExternalVolumeFiles`, {
        files: Object.keys(listOfSelectedFiles),
        spaceId,
        parentId: currentFolder._id,
      });
      return response;
    }
  };

  const createMergeEstimateModal = async (listOfSelectedFiles: any, mergeEstimateName: string) => {
    const constituentEstimateIdArray = Object.values(listOfSelectedFiles).map((val: any) => val.estimateId);

    const params: any = {
      mergeEstimateName,
      spaceId,
      projectId,
      constituentEstimateIds: constituentEstimateIdArray,
    };

    const response: any = await createMergeEstimate(params);
    if (!response.data.status) {
      dispatch(UnnamedEstimateNotSupportedToast(response.data.errorMessage));
    } else if (response.data.status) {
      closeFileMergeModal();
      dispatch(
        showToastNotification({
          content: t("Estimates have been merged successfully."),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
    }
    setOpenMergeEstimateModal(false);
    refreshCurrentFolder();
  };

  const onFileLoad = (files: any[]) => {
    files.forEach((file: any) => {
      if (file?.permission?.read === false) {
        file.isRowDisabled = true;
      }
      if (fileManagerAsPopup && enableOnlyShareableResources && file?.permission?.FOLDER_SHARE === false) {
        file.isRowDisabled = true;
      }
      if (
        Array.isArray(disableFiles) &&
        ["RESOURCE_TYPE_FILE", "RESOURCE_TYPE_MERGED_FILE"].includes(file.resourceType) &&
        disableFiles.includes(file.isEmptyContainer ? file.id : file.fileVersion)
      ) {
        file.isRowDisabled = true;
      }
      if (
        Array.isArray(disableFiles) &&
        file.resourceType == "RESOURCE_TYPE_ISSUE" &&
        disableFiles.includes(file?.issueVersionId)
      ) {
        file.isRowDisabled = true;
      }
      if (
        Array.isArray(disableFiles) &&
        file.resourceType == "RESOURCE_TYPE_TASKS" &&
        disableFiles.includes(file?.taskId)
      ) {
        file.isRowDisabled = true;
      }
      if (Array.isArray(enableFilesTypes) && !enableFilesTypes.includes(file?.resourceType)) {
        file.isRowDisabled = true;
      }
    });
  };

  const handleNoDataRefresh = () => {
    reloadFileManager();
  };

  const getContent = () => {
    if (selectedTab == TAB_THIS_SPACE || selectedTab == TAB_EXTERNAL_SPACE) {
      return (
        <>
          {selectedTab == TAB_EXTERNAL_SPACE && emptyExternal && (
            <div className="flex flex-col gap-10 top-12 absolute bg-white z-20 w-full justify-center items-center bottom-0">
              <div className="flex items-center justify-center flex-col">
                <IconComponent name="NoData" />
                <div className="font-semibold text-lg">{"No Data"}</div>
              </div>
              <ButtonComponent onClick={handleNoDataRefresh}>{t("Refresh")}</ButtonComponent>
            </div>
          )}
          {selectedTab == TAB_THIS_SPACE && emptyThisSpace && (
            <div className="flex flex-col absolute bg-white top-12 z-20 w-full items-center justify-center bottom-0">
              <span>
                <IconComponent name="NoFilesIllustration" />
              </span>
              {getUploadDropDown()}
            </div>
          )}
          <FileManagerComponent
            contextMenuSettings={{
              file: fileManagerOptionsMapper[selectedTab].fileOptions,
              folder: fileManagerOptionsMapper[selectedTab].folderOptions,
              layout: fileManagerOptionsMapper[selectedTab].layoutOptions,
              visible: !disableContextMenu,
            }}
            menuOpen={menuOpen}
            path={path}
            showFolderTree={showFolderTree}
            beforeSending={beforeSending}
            onFileLoad={onFileLoad}
            onSuccess={onSuccess}
            allowDragAndDropUpload={selectedTab == TAB_THIS_SPACE}
            fileColumns={fileColumns}
            setCurrentFolder={setCurrentFolder}
            ref={fileManagerRef}
            toolbarClick={toolbarClick}
            toolbarItems={toolbarItems}
            allowViewFileOptions={false}
            fileManagerData={fileManagerData}
            setFileManagerData={setFileManagerData}
            onFileClick={onFileClick}
            onFileSelect={onFileSelect}
          />
        </>
      );
    } else if (selectedTab == TAB_REVIEWS) {
      return <ReviewsList spaceId={spaceId} archiveToggle />;
    } else if (selectedTab == TAB_SETTINGS) {
      return <Settings projectId={projectId} workspaceId={spaceId} />;
    } else {
      return "";
    }
  };

  const handleModalClose = () => {
    setOpenContainerModal(false);
    setContainerName("");
    setFileTypeValue("");
    setResourceType({});
  };

  const handleCreateContainer = async () => {
    const nameOfContainer = containerName;
    const typeOfContainer = fileTypeValue;
    const fileNomenclatureCorrect = isFileNomenclatureCorrect(nameOfContainer, currentFolder.fileNomenclature);
    if (!fileNomenclatureCorrect) {
      dispatch(
        showToastNotification({
          content: t("File nomenclature is incorrect"),
          type: TOAST_TYPE_ERROR,
        }),
      );
    } else if (
      resourceType.value == "RESOURCE_TYPE_EMBED" ||
      (typeof formValidator.validateAll == "function" && formValidator.validateAll())
    ) {
      handleModalClose();
      const customFields: any = {};
      containerFormTemplate?.forEach((section: any) => {
        section.questionFields.forEach((item: any) => {
          if (item.answer?.value) {
            customFields[item._id] = item.answer.value;
          }
        });
      });
      const res: any = await createContainer({
        name: nameOfContainer,
        type: typeOfContainer,
        hierarchyId: currentFolder.hierarchyId,
        folderType: currentFolder.folderType,
        spaceId,
        customFields,
        resourceType: resourceType.value,
      });
      const response: any = {};
      if (res.data.status) {
        refreshCurrentFolder();
        response.content = `Container ${nameOfContainer} has been created successfully!`;
      } else {
        response.content = SOMETHING_WENT_WRONG;
        response.type = TOAST_TYPE_ERROR;
      }
      dispatch(showToastNotification(response));
    }
  };

  const handleSaveNewName = async () => {
    const oldName = openRenameModal;
    setOpenRenameModal(false);

    const allParams: any = {
      action: "rename",
      path: "/",
      name: oldName,
      newName,
      showFileExtension: true,
      data: [selectedFile],
    };
    beforeSending(allParams);
    if (!allParams.cancel) {
      fileManagerRef.current.showLoading();
      const res: any = await axiosWrapper.post(`${getBackendUrl()}/fileSystemServer/`, {
        ...allParams,
      });
      if (!res.data.status) {
        dispatch(
          showToastNotification({
            content: res.data?.errorMessage,
            type: TOAST_TYPE_ERROR,
          }),
        );
      } else {
        const newFiles = structuredClone(fileManagerData?.files)?.map((f: any) => {
          if (f.id == selectedFile.id) {
            f.name = newName;
            f.dateModified = Date.now();
            f.modifiedBy = userDetails.fullName;
          }
          return f;
        });
        const newObj: any = {
          files: newFiles,
        };
        if (fileManagerData.filteredFiles?.length) {
          const newFilteredFiles = structuredClone(fileManagerData?.filteredFiles).map((f: any) => {
            if (f.id == selectedFile.id) {
              f.name = newName;
            }
            return f;
          });
          newObj.filteredFiles = newFilteredFiles;
        }
        setFileManagerData((prev: any) => ({ ...prev, ...newObj }));
        dispatch(
          showToastNotification({
            content: "Successfully renamed",
            type: TOAST_TYPE_SUCCESS,
          }),
        );
      }
      fileManagerRef.current.hideLoading();
    }
  };

  const handleCloseFolder = () => {
    setOpenFolderCreationModal(false);
    setFolderName(null);
  };

  const handleFolderName = (args: any) => {
    setFolderName(args.value);
  };

  const handleCustomFieldsData = (data: any) => {
    setContainerFormTemplate(data);
  };

  function dropdownItemTemplate(args: any) {
    return (
      <div className="flex items-center gap-1 mt-1">
        <span>{getFileIcon(args.text)}</span>
        <span>{args.text}</span>
      </div>
    );
  }

  const handleEmbedUrl = (args: any) => {
    setFileTypeValue(args.value);
  };

  const handleContainerName = (args: any) => {
    setContainerName(args.value);
  };

  const handleCreateFolder = async () => {
    handleCloseFolder();
    const data: any = {
      hierarchyId: currentFolder.id,
      resourceType: "RESOURCE_TYPE_FOLDER",
      spaceId,
      name: folderName,
      dateModified: Date.now(),
    };
    const allParams: any = {
      action: "create",
      path: "/",
      data: [data],
      name: folderName,
    };
    beforeSending(allParams);
    if (!allParams.cancel) {
      fileManagerRef.current.showLoading();
      const res: any = await axiosWrapper.post(`${getBackendUrl()}/fileSystemServer/`, {
        ...allParams,
      });
      fileManagerRef.current.hideLoading();
      if (res.data.status) {
        dispatch(
          showToastNotification({
            content: "Folder created successfuly",
            type: TOAST_TYPE_SUCCESS,
          }),
        );
        refreshCurrentFolder();
      } else {
        dispatch(
          showToastNotification({
            content: res.data.errorMessage,
            type: TOAST_TYPE_ERROR,
          }),
        );
      }
    }
  };

  const getRenameModal = () => (
    <ModalStateDialogComponent
      footerContent={
        <div className="flex w-full gap-4">
          <ButtonComponent onClick={handleSaveNewName} disabled={!newName} buttonType="gradientButton">
            {t("Save")}
          </ButtonComponent>
          <ButtonComponent
            onClick={() => {
              setOpenRenameModal(false);
              setNewName(null);
            }}
            buttonType="borderButton"
          >
            {t("Cancel")}
          </ButtonComponent>
        </div>
      }
      onCancel={() => {
        setOpenRenameModal(false);
      }}
      headerTitle={t("Rename")}
      modelContent={
        <div className="w-full">
          <div className="my-4">
            <div className="mt-2">
              <TextBoxComponent
                onChange={(args: any) => setNewName(args.value)}
                placeholder={t("Enter Name")}
                value={newName}
              />
            </div>
          </div>
        </div>
      }
      isVisible={openRenameModal}
      width="25%"
      allowModalPadding
    />
  );

  const getFolderCreationModal = () => (
    <ModalStateDialogComponent
      footerContent={
        <div className="flex w-full gap-4">
          <ButtonComponent onClick={handleCreateFolder} disabled={!folderName} buttonType="gradientButton">
            {t("Create")}
          </ButtonComponent>
          <ButtonComponent
            onClick={() => {
              handleCloseFolder();
            }}
            buttonType="borderButton"
          >
            {t("Discard")}
          </ButtonComponent>
        </div>
      }
      onCancel={handleCloseFolder}
      headerTitle={t("New Folder")}
      modelContent={
        <div className="w-full">
          <div className="my-4">
            <div className="mt-2">
              <TextBoxComponent onChange={handleFolderName} placeholder={t("Enter your folder name")} />
            </div>
          </div>
        </div>
      }
      isVisible={openFolderCreationModal}
      width="25%"
      allowModalPadding
    />
  );

  const handleNomenclatureChange = (e: any, args: any, field: any, index: number) => {
    const value = e.value || e.target.value;
    let nomenclatureArr: any[] = [];
    if (nomenclatureRef.current) {
      nomenclatureArr = nomenclatureRef.current;
    }

    nomenclatureArr[index] = value;
    nomenclatureRef.current = nomenclatureArr;

    const separator = _.get(currentFolder, "fileNomenclature.separator", "");
    setContainerName(nomenclatureArr.join(separator));
  };

  const newContainerCreateModal = () => (
    <div className="w-full">
      <div className="my-4">
        <div>{t("Format")}</div>
        <div className="mt-2">
          <FormControl
            fullWidth
            sx={{
              "& .MuiInputBase-root": {
                height: 32,
              },
            }}
          >
            <Select
              value={resourceType?.text}
              onChange={(e: any) => {
                setFileTypeValue("");
                setResourceType({ text: e.target.text, value: e.target.value });
              }}
            >
              <MenuItem value="RESOURCE_TYPE_FILE">{t("File")}</MenuItem>
              <MenuItem value="RESOURCE_TYPE_EMBED">{t("Embed")}</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>
      <div className="my-4">
        <div> {t("Name")} </div>
        {currentFolder?.fileNomenclature?.fields ? (
          <div className="mt-2 flex gap-2">
            {currentFolder.fileNomenclature.fields.map((field: any, index: number) => (
              <NomenclatureField
                key={`${field._id}-${index}`}
                args={{ id: 1 }}
                field={field}
                index={index}
                value=""
                handleNomenclatureChange={handleNomenclatureChange}
              />
            ))}
          </div>
        ) : (
          <div className="mt-2">
            <TextBoxComponent onChange={handleContainerName} placeholder={t("Container Name")} />
          </div>
        )}
      </div>
      {resourceType.value == "RESOURCE_TYPE_EMBED" && (
        <div className="my-4">
          <div>{t("URL")}</div>
          <div className="mt-2">
            <TextBoxComponent onChange={handleEmbedUrl} placeholder={t("Embed URL")} />
          </div>
        </div>
      )}
      {resourceType.value == "RESOURCE_TYPE_FILE" && (
        <>
          <div className="my-4">
            <div>{t("File Type")}</div>
            <div className="mt-2">
              <DropDownDefaultComponent
                placeholder={t("Select file Type")}
                allowFiltering
                width="100%"
                dataSource={containerFileTypes.map((x: string) => ({ text: x }))}
                itemTemplate={dropdownItemTemplate}
                valueTemplate={dropdownItemTemplate}
                change={(args: any) => {
                  setFileTypeValue(args.itemData.text);
                }}
              />
            </div>
          </div>
          <div className="my-4">
            {containerFormTemplate && (
              <FormPreview
                formData={{ template: containerFormTemplate }}
                disabled={false}
                allowPadding={false}
                allowBorder={false}
                fullWidthInput
                removeIcons
                handleData={handleCustomFieldsData}
                formValidator={formValidator}
              />
            )}
          </div>
        </>
      )}
    </div>
  );

  const getContainerModal = () => (
    <ModalStateDialogComponent
      footerContent={
        <div className="flex w-full gap-4">
          <ButtonComponent
            onClick={handleCreateContainer}
            disabled={containerName.trim() == "" || !fileTypeValue}
            buttonType="gradientButton"
          >
            {t("Create")}
          </ButtonComponent>
          <ButtonComponent
            onClick={() => {
              handleModalClose();
            }}
            buttonType="borderButton"
          >
            {t("Discard")}
          </ButtonComponent>
        </div>
      }
      headerTitle={t("New Container")}
      onCancel={handleModalClose}
      modelContent={newContainerCreateModal()}
      isVisible={openContainerModal}
      width="60%"
      allowModalPadding
    />
  );

  const getFileManagerPopup = () => {
    const selectedFiles = getSelectedFilesInFileManager();

    if (openFileImport) {
      return (
        <FileManagerAsPopup
          projectId={projectId}
          handleFileSelectedButtonClick={handleFileImportCallback}
          handleFileSelectedCancelClick={closeFileImportPopup}
          workspaceId={spaceId}
          id="fileManagerAsPopup"
          useAttachedExternalVolume
          disableContextMenu
          heading={t("Import Files")}
          hideAllTabs
          minimumFiles={0}
        />
      );
    } else if (openMergeEstimateModal) {
      return (
        <FileManagerAsPopup
          projectId={projectId}
          handleFileSelectedButtonClick={createMergeEstimateModal}
          handleFileSelectedCancelClick={closeMergeEstimateModal}
          workspaceId={spaceId}
          id="fileManagerAsPopup"
          hideIssues
          hideTasks
          hideClashTests
          hideSchedules
          hideContracts
          heading={t("Merged Estimates")}
          allowInput
          inputLabel="Merged Estimate Name"
          minimumFiles={0}
          selectedFilesData={selectedFiles}
          createMerge
        />
      );
    } else if (openMergeModal) {
      return (
        <FileManagerAsPopup
          projectId={projectId}
          handleFileSelectedButtonClick={saveFileMergeModal}
          handleFileSelectedCancelClick={closeFileMergeModal}
          workspaceId={spaceId}
          id="fileManagerAsPopup"
          hideIssues
          hideTasks
          hideClashTests
          hideSchedules
          hideContracts
          hideReviews
          hideAllTabs
          heading={t("Merge")}
          allowInput
          inputLabel="Name"
          minimumFiles={0}
          selectedFilesData={selectedFiles}
          createMerge
          addEmptyContainerToList
        />
      );
    } else if (openFileModalExternal) {
      return (
        <FileManagerAsPopup
          projectId={projectId}
          handleFileSelectedCancelClick={closeCreateShortcutModal}
          workspaceId={spaceId}
          id="fileManagerAsPopup"
          hideIssues
          hideTasks
          heading={openFileModalExternal == "shortcut" ? t("Create Shortcut") : t("Consume File(s)")}
          hideEstimates
          hideSchedules
          hideContracts
          hideExternalSpace
          hideReviews
          createShortcut
          consumeFiles={openFileModalExternal == "consume"}
          shortCutData={shortCutData}
          externalFolderData={{
            _id: currentFolder.transmittalVersionId,
            indexAtProjectLevel: currentFolder.transmittalCounter,
          }}
        />
      );
    } else {
      return "";
    }
  };

  const handleOpenLatestClickInTransmittal = () => {
    const fileId = sharingData[0].id;
    const location: any = getViewerUrl({
      fileVersionId: fileId,
      transmittalVersionId: sharingData[0].transmittalVersionId,
      projectId,
    });

    setOpenLink(false);
    handleLocationOpen(location);
  };

  const handleCloseClickInTransmittal = () => {
    setOpenModalForTransmittalFile(false);
    setSharingData([]);
  };

  const openCurrentFileVersionInTransmittal = () => {
    const fileId = filesSelectedToMerge[0].fileVersion;
    let transmittalVersionId = "";
    if (filesSelectedToMerge[0].transmittalVersionId) {
      transmittalVersionId = filesSelectedToMerge[0].transmittalVersionId;
    }

    const location: any = getViewerUrl({
      fileVersionId: fileId,
      transmittalVersionId,
      projectId,
    });

    setOpenLink(false);
    handleLocationOpen(location);
  };

  const handleOpenCurrentClickInTransmittal = () => {
    openCurrentFileVersionInTransmittal();
  };

  return (
    <div className="w-full h-full flex relative bg-white flex-col" data-testid="filemanagerComponentRoot">
      {!hideAllTabs && getHeaderTabs()}
      {getContent()}
      {openDeleteConfirmationModal && (
        <FileDelete
          workspaceId={spaceId}
          selectedFiles={selectedFilesToDelete}
          onCloseModal={handleDeleteModalClose}
          onDeleteSuccess={handleDeleteSuccess}
          path={path}
        />
      )}
      {showContainerImportModal && (
        <ExcelImport
          showImportModal={showContainerImportModal}
          setShowImportModal={setShowContainerImportModal}
          source={excelImportSources.FILES}
          sourceId="a"
          refreshDataGrid={refreshFileManager}
          currentData={{
            projectId,
            hierarchyId: currentFolder.hierarchyId,
            parentId: currentFolder.hierarchyId,
            spaceId,
          }}
        />
      )}
      {openRenameModal && getRenameModal()}
      {openCreateTransmittalModal && (
        <CreateTransmittal
          isOpen={openCreateTransmittalModal}
          onClose={() => setOpenCreateTransmittalModal(false)}
          projectId={projectId}
          selectedSpaceId={spaceId}
          selectedReferences={selectedFile}
        />
      )}
      {createReviewModal.show && (
        <CreateReviewModal
          spaceId={spaceId}
          refreshGrid={refreshFileManager}
          closeModal={closeReviewModal}
          projectId={projectId}
          initialFiles={getSelectedFilesInFileManager()}
        />
      )}
      {openModalForTransmittalFile && (
        <div
          className="w-full h-full absolute m-auto z-20"
          style={{
            backgroundColor: "var(--background-scrim)",
          }}
        >
          <div
            className="bg-white p-4 w-2/5 absolute"
            style={{
              top: "40%",
              insetInlineStart: "30%",
            }}
          >
            <div style={{ display: "grid" }} className="dialogContent">
              <div>
                {t(
                  "The latest version of this file has been received in TS- on . Would you like to open that instead?",
                )}
              </div>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                paddingTop: "16px",
                gridColumnGap: "16px",
              }}
            >
              <Box
                className="cursor-pointer pe-3 ps-3"
                style={{
                  gridColumnStart: "1",
                  color: "white",
                  background: "#0171B9",
                }}
                onClick={handleOpenLatestClickInTransmittal}
              >
                {t("Open latest")}
              </Box>
              <Box
                className="cursor-pointer pe-3 ps-3"
                style={{
                  gridColumnStart: "2",
                  color: "white",
                  background: "#0171B9",
                }}
                onClick={handleOpenCurrentClickInTransmittal}
              >
                {t("Open current")}
              </Box>
              <Box className="cursor-pointer ps-3 pe-3" onClick={handleCloseClickInTransmittal}>
                {t("Cancel")}
              </Box>
            </div>
          </div>
        </div>
      )}
      {openContainerModal && getContainerModal()}
      {openFolderCreationModal && getFolderCreationModal()}
      {(openFileImport || openMergeEstimateModal || openMergeModal || openFileModalExternal) && getFileManagerPopup()}
    </div>
  );
};

export default FileManager;
